import {publishClientSideMetrics} from "../handler/ParentDataHandler";

export function getTime(time) {
    if (time == null || time === '') {
        return ''
    }
    let date = new Date(time);
    let hour = date.getHours();
    let minutes = date.getMinutes();
    return ((hour < 10 ? '0' + hour : hour) + ":" + (minutes < 10 ? '0' + minutes : minutes))
}

export function getRegion() {
    let location = window.location.href
    let region = "US"
    if (location.includes("ui.ivsna")) {
        region = "US"
    } else if (location.includes("ui.ivseu")) {
        region = "EU"
    } else if (location.includes("ui.ivsjp")) {
        region = "FE"
    }
    return region;
}

export function getLocaleDateTime(dateTime) {
    if (dateTime) {
        const date = new Date(dateTime);
        let hour = date.getHours();
        let minutes = date.getMinutes();
        return date.toLocaleDateString() + " " + ((hour < 10 ? '0' + hour : hour) + ":" + (minutes < 10 ? '0' + minutes : minutes));
    }
    return ""
}

export function getSplitViewHeaders(metrics) {
    return metrics[Object.keys(metrics).reduce((a, b) =>
        Object.keys(metrics[a]).length > Object.keys(metrics[b]).length ? a : b)];
}

export const getAliasFromLoginId = (loginId) => {
    if (loginId.indexOf('@') !== -1) {
        return loginId.substr(0, loginId.indexOf('@'));
    }
    return loginId;
}

/**
 * This method return the refresh interval in milliseconds
 * @returns {number}
 */
export function getRefereshInterval() {
    return 60 * 1000;
}

export function logOperationalMetric(startTime, processName, metricName, isSuccess) {
    isSuccess ?
        publishToCSM({
            startTime: startTime,
            processName: processName,
            metricName: metricName
        }) : publishErrorToCSM({
            processName: processName,
            metricName: metricName
        })
}

export function publishToCSM(args) {
    let metricValue = getTimeDiff(args.startTime);
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, 1, metricTypeEnum.COUNT);
    const timeMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, metricValue, metricTypeEnum.TIME);
    publishClientSideMetrics(countMetricReq);
    publishClientSideMetrics(timeMetricReq);
}

export function publishErrorToCSM(args) {
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName + "Error" , 1, metricTypeEnum.COUNT);
    publishClientSideMetrics(countMetricReq);
}

export function publishCountToCSM(args) {
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName , 1, metricTypeEnum.COUNT);
    publishClientSideMetrics(countMetricReq);
}

function getTimeDiff(time) {
    return Date.now() - time ;
}

const metricTypeEnum = {
    COUNT: "count",
    TIME: "time"
};

function publishClientSideMetricsRequest(processName, metricName, metricValue, metricType) {
    return {
        processName: processName,
        metricName: metricName,
        metricValue: metricValue,
        metricType: metricType
    }
}

export function parseCapabilitiesResponse(response) {
    return response ? JSON.parse(response.capability) : '';
}

export const chainWalk = (func, defaultValue) => {
    try {
        const value = func()
        return (value === null || value === undefined) ? defaultValue : value;
    } catch (e) {
        return defaultValue
    }
}



// WEBPACK FOOTER //
// ./src/components/util/Util.js